let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l4e09")).then(() => parcelRequire('14875'));